import { Component, Input } from '@angular/core';

import { BreadcrumbItem } from '../../../entities/index';

@Component({
  selector: 'app-page-head',
  templateUrl: './page-head.html'
})
export class PageHeadComponent {
  @Input()
  title: string;

  @Input()
  breadcrumbs: BreadcrumbItem[] = [];

  @Input()
  nbResults = 0;

  @Input()
  subText: string;
}



// WEBPACK FOOTER //
// /app/src/app/components/core/page-head/page-head.component.ts